/* Тема 4 - слоят за измерване. Пълни window.dataLayer със стандартните
   GA4 e-commerce събития. Никакви заявки навън - само dataLayer.push;
   изпращането е работа на GTM/пиксела, когато бъде вързан. */
(function () {
  window.dataLayer = window.dataLayer || [];
  function push(sabitie, danni) {
    window.dataLayer.push(Object.assign({ event: sabitie }, danni || {}));
  }

  /* view_item / view_item_list - от JSON-LD и от страницата.
     На страницата има и Store JSON-LD (в head) - търси се точно Product. */
  var produktLd = null;
  document.querySelectorAll('script[type="application/ld+json"]').forEach(function (ld) {
    try {
      var d = JSON.parse(ld.textContent);
      if (d['@type'] === 'Product') produktLd = d;
    } catch (e) { /* счупен JSON-LD не бива да чупи страницата */ }
  });
  if (produktLd) {
    push('view_item', {
      ecommerce: {
        items: [{ item_name: produktLd.name,
                  item_brand: produktLd.brand && produktLd.brand.name,
                  price: produktLd.offers && produktLd.offers[0] && produktLd.offers[0].price }]
      }
    });
  } else {
    var spisak = document.querySelector('.t4-grid');
    if (spisak) {
      push('view_item_list', {
        item_list_name: document.title,
        broy: spisak.querySelectorAll('.t4-karta').length
      });
    }
  }

  /* add_to_cart / begin_checkout / search - делегирано на submit */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action) return;
    if (f.action.indexOf('/cart/add') !== -1) {
      var id = f.querySelector('[name="id"]:checked') || f.querySelector('[name="id"]');
      push('add_to_cart', { variant_id: id && id.value });
    } else if (f.action.indexOf('/cart') !== -1 && e.submitter && e.submitter.name === 'checkout') {
      push('begin_checkout', {});
    } else if (f.action.indexOf('/search') !== -1) {
      var q = f.querySelector('[name="q"]');
      push('search', { search_term: q && q.value });
    }
  }, true);

  /* select_item - клик по карта */
  document.addEventListener('click', function (e) {
    var karta = e.target.closest && e.target.closest('.t4-karta');
    if (!karta) return;
    var ime = karta.querySelector('.t4-karta__ime');
    if (ime) push('select_item', { item_name: ime.textContent.trim() });
  }, true);
})();
